/**
 * Csv Schema of ResponseRoboCnpj
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponseRoboCnpj} from '@/model/resource/ResponseRoboCnpj'

/* TODO: review generated schema */
export class CsvResponseRoboCnpjSchema extends Schema {
  readonly name = 'CsvResponseRoboCnpj'

  readonly fieldSet: FieldSet<ResponseRoboCnpj> = {
    idResponsePk: schema => schema.model.idResponsePk,
    cnpj: schema => Helper.cnpj(schema.model.cnpj),
    response: schema => schema.model.response,
  }
}
